import {requestConfig} from "../config.js";

/**
 * Получить информацию о договоре пользователя
 */
export default async function apiFetchContract() {
  const response = await requestConfig.get("api/v2/user/info/");
  return response.data;
}
